module.exports = __webpack_public_path__ + "img/57_28.80ddfb8e.png";